import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  catchError,
  EMPTY,
  expand,
  finalize,
  forkJoin,
  last,
  map,
  of,
  scan,
  Subject,
  switchMap,
  takeUntil
} from 'rxjs';
import { IncidentService } from 'src/app/services/api/incident.service';
import { CognitoService } from 'src/app/services/cognito.service';
import Swal from 'sweetalert2';
import { FileService } from '../../services/api/file.service';
import { LoadingService } from '../../services/loading.service';
import { DialogAddOpIncidentComponent } from '../dialog-add-op-incident/dialog-add-op-incident.component';
import { DialogDeleteOpIncidentComponent } from '../dialog-delete-op-incident/dialog-delete-op-incident.component';
import { DialogUpdateOpIncidentComponent } from '../dialog-update-op-incident/dialog-update-op-incident.component';
import {
  OpIncident,
  OpIncidentTableRow,
  OpIncidentTypes
} from '../incidents.types';
import { DialogSelectServiceComponent } from './dialog-select-service/dialog-select-service.component';

@Component({
  selector: 'app-operativas',
  templateUrl: './operativas.component.html',
  styleUrls: ['./operativas.component.css']
})
export class OperativasComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isLoading: boolean = false;
  loadingMessage: string = 'Cargando incidencias operativas...';
  authUsername: string | null = null;
  hasError = false;
  textError: string | null = null;
  originalOpIncidentTableData: OpIncidentTableRow[] = [];
  opIncidentTableSource = new MatTableDataSource<OpIncidentTableRow>();
  opIncidentColumns: string[] = [
    'createdAt', // Fecha de creación de la incidencia op
    'fileNumber', // Número de File
    'nameClient', // Cliente del File
    'serviceName', // Si tiene, nombre del servicio asociado a la incidencia op
    'appendService', // Botón para asignar la incidencia op a un servicio (si no tiene uno asociado)
    'serviceType', // Si tiene, tipo de servicio asociado a la incidencia op

    'description', // Descripción de la incidencia op
    'reportedBy',

    'ds', // Destination Specialist del File

    'opIncidentType', // Tipo de incidencia op
    'incidentStatus', // Estado de la incidencia op

    'solutionDate', // Fecha de solución de la incidencia op
    'solutionTime', // Días/horas de solución de la incidencia op
    'actions', // Acciones tomadas

    'editar',
    'addOpIncident',
    'eliminar'
  ];

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.opIncidentTableSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.opIncidentTableSource.sort = value;
  }
  showFilters = false;

  idItinerario: string = '';

  startDate: Date | null = null;
  endDate: Date | null = null;
  startDateSelected: Date | null = null;
  endDateSelected: Date | null = null;
  selectedResolucion: string | null = null;

  selectedIncidentStatus: string | null = null;
  opIncidentStatus = ['CREATED', 'IN_PROGRESS', 'FINISHED'];

  selectedServiceType: string | null = null;
  opIncidentServicesTypes: Array<{
    value: string;
    viewValue: string;
  }> = [];

  selectedOpIncidentType: string | null = null;
  opIncidentTypeOptions: OpIncidentTypes[] = [
    'Discrepancia en el itinerario pax / Biblia',
    'Falta de información y comunicación',
    'Errores en compra / reservas',
    'Tardanza u omisión de servicios',
    'Inconformidad de servicios',
    'Incidencia con aerolíneas',
    'Incidentes médicos',
    'Incidencias con trenes',
    'Robos o pérdidas',
    'Paros',
    'Otros'
  ];

  constructor(
    private readonly incidentService: IncidentService,
    private readonly fileService: FileService,
    private readonly cognitoService: CognitoService,
    public loadingService: LoadingService,
    public dialog: MatDialog
  ) {
    console.log('estoy en el contructor de incidencias');
  }
  ngOnInit(): void {
    this.loadUser();
    this.loadOpIncidentsTable();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadUser() {
    return this.cognitoService
      .getUsername()
      .then((username) => {
        console.log({ username });
        this.authUsername = username;
        return username;
      })
      .catch((err) => {
        console.error('Error fetching username:', err);
        this.textError =
          'No se pudo cargar usuario, por favor vuelva a iniciar sesión.';
        throw err;
      });
  }

  // "CREADO",
  // "ENPROGRESO",
  // "SOLUCIONADO",
  // "CERRADO",
  // "ELIMINADO"

  renameOpIncidentStatus(status: string) {
    switch (status) {
      case 'CREATED':
        return 'Creado';
      case 'IN_PROGRESS':
        return 'En Proceso';
      case 'FINISHED':
        return 'Solucionado';
      default:
        return status;
    }
  }

  // RenameEstado(name: string) {
  //   switch (name) {
  //     case 'CREADO':
  //       return 'Creado';

  //     case 'ENPROGRESO':
  //       return 'En Proceso';

  //     case 'SOLUCIONADO':
  //       return 'Solucionado';

  //     case 'CERRADO':
  //       return 'Cerrado';

  //     default:
  //       return name?.toLowerCase();
  //   }
  // }

  toggleFilters() {
    this.showFilters = !this.showFilters;
    if (!this.showFilters) {
      this.selectedOpIncidentType = null;
      this.selectedServiceType = null;
      this.selectedIncidentStatus = null;
      this.selectedResolucion = null;
      this.startDate = null;
      this.endDate = null;
      this.applyFilterSelect();
    }
  }
  refreshData() {
    this.loadOpIncidentsTable();
  }

  private fetchAllOpIncidents(selectedFields: string[]) {
    return this.incidentService
      .findAllOpIncidents({
        selectedFields,
        startEvaluatedKeyId: undefined
      })
      .pipe(
        expand((response) => {
          const nextStartEvaluatedKeyId =
            response.findAllOpIncidents?.lastEvaluatedKeyId ?? undefined;

          if (!nextStartEvaluatedKeyId) {
            return EMPTY;
          }

          return this.incidentService.findAllOpIncidents({
            selectedFields,
            startEvaluatedKeyId: nextStartEvaluatedKeyId
          });
        }),
        map((response) => response.findAllOpIncidents?.opIncidents ?? []),
        scan((allOpIncidents, pageOpIncidents) => {
          const nextAllOpIncidents = [...allOpIncidents, ...pageOpIncidents];
          this.loadingMessage = `Cargando incidencias operativas... ${nextAllOpIncidents.length} registros cargados`;
          return nextAllOpIncidents;
        }, [] as OpIncident[]),
        last()
      );
  }

  loadOpIncidentsTable() {
    this.isLoading = true;
    this.hasError = false;
    this.textError = null;
    this.loadingMessage = 'Cargando incidencias operativas...';

    const selectedOpIncidentFields = [
      'id',
      'itineraryId',
      'serviceId',
      'opIncidentType',
      'incidentStatus',
      'description',
      'reportedBy',
      'solutionDate',
      'solutionTime',
      'actions',
      'createdAt'
    ];

    this.fetchAllOpIncidents(selectedOpIncidentFields)
      .pipe(
        switchMap((allOpIncidents) => {
          if (allOpIncidents.length === 0)
            return of([] as OpIncidentTableRow[]);

          const allItineraryIds = Array.from(
            new Set(allOpIncidents.map((incident) => incident.itineraryId))
          ) as string[];

          const allServiceIds = Array.from(
            new Set(
              allOpIncidents
                .map((incident) => incident.serviceId)
                .filter(Boolean)
            )
          ) as string[];

          if (allItineraryIds.length === 0) {
            const emptyMapped: OpIncidentTableRow[] = allOpIncidents.map(
              (op) => ({
                ...op,
                fileNumber: null,
                nameClient: null,
                ds: null,
                serviceName: null,
                serviceType: null
              })
            );
            return of(emptyMapped);
          }

          return forkJoin({
            itineraries: this.fetchItinerariesByIds(allItineraryIds),
            services:
              allServiceIds.length > 0
                ? this.fetchServicesByIds(allServiceIds)
                : of([])
          }).pipe(
            map(
              ({
                itineraries,
                services
              }: {
                itineraries: any[];
                services: any[];
              }) => {
                return allOpIncidents.map((opIncident) => {
                  const matchedItinerary = itineraries.find(
                    (itinerary) => itinerary.id === opIncident.itineraryId
                  );
                  const matchedService = services.find(
                    (service) => service.id === opIncident.serviceId
                  );
                  return {
                    ...opIncident,
                    fileNumber:
                      `${matchedItinerary?.fileNumber}${matchedItinerary?.fileExtend || ''}` ||
                      null,
                    nameClient: matchedItinerary?.nameClient || null,
                    ds: matchedItinerary?.usuario || null,
                    serviceName: matchedService?.nombreServicio || null,
                    serviceType: matchedService?.tipoServicio || null
                  } as OpIncidentTableRow;
                });
              }
            )
          );
        }),
        catchError((err) => {
          console.error('Error fetching OpIncidents:', err);
          this.hasError = true;
          this.showOperationAlert({
            variant: 'error',
            title: 'Error al cargar las incidencias operativas',
            message:
              'No se pudo cargar la información de las incidencias operativas. Inténtalo nuevamente.',
            confirmText: 'Reintentar',
            onConfirm: () => this.loadOpIncidentsTable()
          });
          return of([] as OpIncidentTableRow[]);
        }),
        finalize(() => {
          console.log('fetchAllOpIncidents request completed');
          this.isLoading = false;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (mappedOpIncidents) => {
          if (mappedOpIncidents.length === 0) {
            this.opIncidentTableSource.data = [];
          }
          console.log({ mappedOpIncidents });
          this.opIncidentTableSource.data = mappedOpIncidents;
          this.originalOpIncidentTableData = mappedOpIncidents;
          this.opIncidentTableSource.paginator = this.paginator;
          this.opIncidentTableSource.sort = this.sort;

          this.opIncidentServicesTypes = Array.from(
            new Set(
              mappedOpIncidents
                .filter((opIncidentRow) => opIncidentRow.serviceType != null)
                .map((opIncidentRow) => opIncidentRow.serviceType!)
            )
          ).map((serviceType) => ({
            value: serviceType,
            viewValue: serviceType
          }));
          this.textError = null;
        },
        error: (err) => {
          console.error('Error in subscription to fetchAllOpIncidents:', err);
          this.hasError = true;
          this.textError =
            'No se pudo cargar la información de las incidencias operativas. Inténtalo nuevamente.';
        }
      });
  }

  fetchItinerariesByIds(itineraryIds: string[]) {
    return this.fileService
      .getItineraryByIds({
        ids: itineraryIds,
        projectionExpression: 'id, fileNumber, fileExtend, nameClient, usuario'
      })
      .pipe(
        map((response: any) => {
          return response.getItineraryByIds || [];
        })
      );
  }

  fetchServicesByIds(serviceIds: string[]) {
    return this.fileService
      .getServicesByIds(serviceIds, 'id, nombreServicio, tipoServicio')
      .pipe(
        map((response: any) => {
          return response.getServicesByIds || [];
        })
      );
  }

  private showOperationAlert(options: {
    variant: 'success' | 'error';
    title: string;
    message: string;
    confirmText: string;
    onConfirm?: () => void;
  }) {
    Swal.fire({
      html: `
        <div class="operativas-swal-content">
          <div
            class="operativas-swal-icon-shell operativas-swal-icon-shell--${options.variant}"
          >
            ${this.getOperationAlertIcon(options.variant)}
          </div>
          <div class="operativas-swal-copy">
            <h2 class="operativas-swal-title">${options.title}</h2>
            <p class="operativas-swal-message">${options.message}</p>
          </div>
        </div>
      `,
      width: '900px',
      padding: '0',
      background: '#ffffff',
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: options.confirmText,
      buttonsStyling: false,
      allowOutsideClick: true,
      customClass: {
        popup: `operativas-swal-popup operativas-swal-popup--${options.variant}`,
        htmlContainer: 'operativas-swal-html-container',
        actions: 'operativas-swal-actions',
        confirmButton: `operativas-swal-confirm-button operativas-swal-confirm-button--${options.variant}`,
        closeButton: 'operativas-swal-close-button'
      }
    }).then((result) => {
      if (result.isConfirmed && options.onConfirm) {
        options.onConfirm();
      }
    });
  }

  private getOperationAlertIcon(variant: 'success' | 'error') {
    if (variant === 'success') {
      return `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="operativas-swal-icon operativas-swal-icon--success"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M9 12l2 2l4 -4"></path>
        </svg>
      `;
    }

    return `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="operativas-swal-icon operativas-swal-icon--error"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M9 9l6 6"></path>
        <path d="M15 9l-6 6"></path>
      </svg>
    `;
  }

  private attachServiceToIncident(
    opIncidentRow: OpIncidentTableRow,
    selectedService: {
      serviceId: string;
      serviceName: string;
      serviceType: string;
    }
  ) {
    if (!this.authUsername) {
      this.showOperationAlert({
        variant: 'error',
        title: 'Error al adjuntar servicio',
        message:
          'No se pudo adjuntar el servicio a la incidencia. Inténtalo nuevamente.',
        confirmText: 'Aceptar'
      });
      return;
    }

    this.incidentService
      .updateOpIncident({
        incidentId: opIncidentRow.id,
        itineraryId: opIncidentRow.itineraryId,
        serviceId: selectedService.serviceId,
        modifiedBy: this.authUsername
      })
      .subscribe({
        next: ({ updateOpIncident }) => {
          if (updateOpIncident) {
            this.opIncidentTableSource.data =
              this.opIncidentTableSource.data.map((opIncident) => {
                if (opIncident.id === opIncidentRow.id) {
                  return {
                    ...opIncident,
                    serviceId: selectedService.serviceId,
                    serviceName: selectedService.serviceName,
                    serviceType: selectedService.serviceType
                  };
                }
                return opIncident;
              });

            this.showOperationAlert({
              variant: 'success',
              title: 'Servicio adjuntado correctamente',
              message: 'El servicio fue adjuntado a la incidencia con éxito.',
              confirmText: 'Volver al listado de incidencias'
            });
            return;
          }

          this.showOperationAlert({
            variant: 'error',
            title: 'Error al adjuntar servicio',
            message:
              'No se pudo adjuntar el servicio a la incidencia. Inténtalo nuevamente.',
            confirmText: 'Reintentar',
            onConfirm: () =>
              this.attachServiceToIncident(opIncidentRow, selectedService)
          });
        },
        error: (error) => {
          console.error('Error updating operational incident', error);
          this.showOperationAlert({
            variant: 'error',
            title: 'Error al adjuntar servicio',
            message:
              'No se pudo adjuntar el servicio a la incidencia. Inténtalo nuevamente.',
            confirmText: 'Reintentar',
            onConfirm: () =>
              this.attachServiceToIncident(opIncidentRow, selectedService)
          });
        }
      });
  }

  openDialogAppendService(opIncidentRow: OpIncidentTableRow) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      itineraryId: opIncidentRow.itineraryId,
      associatedServiceIds: this.opIncidentTableSource.data
        .filter((op) => op.serviceId)
        .map((op) => op.serviceId) as string[],
      availableServices: undefined,
      activityDayNumber: undefined,
      activityDayName: undefined
    };

    dialogConfig.width = '80%';
    dialogConfig.maxHeight = '750px';
    dialogConfig.maxWidth = '700px';

    const dialogRef = this.dialog.open(
      DialogSelectServiceComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log({ dialogResult: result });
      if (!result || result?.event === 'nothing') return;
      if (!result.op_incident_append_service.serviceId) {
        this.showOperationAlert({
          variant: 'error',
          title: 'Error al adjuntar servicio',
          message:
            'No se pudo adjuntar el servicio a la incidencia. Inténtalo nuevamente.',
          confirmText: 'Reintentar',
          onConfirm: () => this.openDialogAppendService(opIncidentRow)
        });
        return;
      }

      this.attachServiceToIncident(opIncidentRow, {
        serviceId: result.op_incident_append_service.serviceId,
        serviceName: result.op_incident_append_service.serviceName,
        serviceType: result.op_incident_append_service.serviceType
      });
    });
  }

  openDialogAddOpIncident(opIncidentRow: OpIncidentTableRow) {
    console.log({ opIncidentRow });
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      itineraryId: opIncidentRow.itineraryId,
      associatedService: {
        serviceId: opIncidentRow.serviceId,
        serviceName: opIncidentRow.serviceName,
        serviceType: opIncidentRow.serviceType
      },
      fileNumber: opIncidentRow.fileNumber,
      availableServices: undefined,
      activityDayNumber: undefined,
      activityDayName: undefined
    };

    dialogConfig.width = '80%';
    dialogConfig.maxHeight = '750px';
    dialogConfig.maxWidth = '700px';

    const dialogRef = this.dialog.open(
      DialogAddOpIncidentComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (!result || result?.event === 'nothing') return;
      if (result.event === 'op_incident_create') {
        const newTableRow: OpIncidentTableRow = {
          ...result.op_incident_create,
          fileNumber: opIncidentRow?.fileNumber || null,
          nameClient: opIncidentRow?.nameClient || null,
          ds: opIncidentRow?.ds || null
        };
        const index = this.opIncidentTableSource.data.indexOf(opIncidentRow);
        if (index === -1) return;
        this.opIncidentTableSource.data = [
          ...this.opIncidentTableSource.data.slice(0, index + 1),
          newTableRow,
          ...this.opIncidentTableSource.data.slice(index + 1)
        ];
      }
    });
  }

  openDialogUpdateOpIncident(opIncidentTableRow: OpIncidentTableRow) {
    console.log({ opIncidentTableRow });

    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = opIncidentTableRow;

    dialogConfig.width = '80%';
    dialogConfig.maxHeight = '750px';
    dialogConfig.maxWidth = '700px';

    const dialogRef = this.dialog.open(
      DialogUpdateOpIncidentComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log({ dialogRes: result });
      if (!result || result.event === 'nothing') return;
      if (result?.event === 'op_incident_update') {
        this.opIncidentTableSource.data = this.opIncidentTableSource.data.map(
          (opIncidentRow) => {
            if (opIncidentRow.id === result.op_incident_update.incidentId) {
              return {
                ...opIncidentRow,
                ...result.op_incident_update
              };
            }
            return opIncidentRow;
          }
        );
      }
    });
  }

  openDialogDeleteOpIncident(opIncidentTableRow: OpIncidentTableRow) {
    console.log({ opIncidentTableRow });
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      opIncidentId: opIncidentTableRow.id,
      itineraryId: opIncidentTableRow.itineraryId,
      serviceId: opIncidentTableRow.serviceId,
      opIncidentType: opIncidentTableRow.opIncidentType
    };

    const dialogRef = this.dialog.open(
      DialogDeleteOpIncidentComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log({ result });
      if (!result || result?.event === 'nothing') return;
      if (
        result.event === 'op_incident_delete' &&
        result.op_incident_delete === true
      ) {
        this.opIncidentTableSource.data =
          this.opIncidentTableSource.data.filter(
            (opIncident) => opIncident.id !== opIncidentTableRow.id
          );
      }
    });
  }

  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.opIncidentTableSource.filter = filterValue;
  }
  applyFilterSelect() {
    let updatedOpIncidentData = this.originalOpIncidentTableData;

    if (this.startDateSelected || this.endDateSelected) {
      updatedOpIncidentData = updatedOpIncidentData?.filter((opIncidentRow) => {
        const itemDate = new Date(opIncidentRow.createdAt).getTime();

        if (this.startDateSelected && this.endDateSelected) {
          return (
            itemDate >= this.startDateSelected.getTime() &&
            itemDate <= this.endDateSelected.getTime()
          );
        } else if (this.startDateSelected) {
          return itemDate >= this.startDateSelected.getTime();
        } else if (this.endDateSelected) {
          return itemDate <= this.endDateSelected.getTime();
        }
        return true;
      });
    }

    if (this.selectedIncidentStatus) {
      updatedOpIncidentData = updatedOpIncidentData?.filter((opIncidentRow) => {
        return opIncidentRow.incidentStatus === this.selectedIncidentStatus;
      });
    }

    if (this.selectedServiceType) {
      updatedOpIncidentData = updatedOpIncidentData?.filter((opIncidentRow) => {
        return opIncidentRow.serviceType === this.selectedServiceType;
      });
    }
    if (this.selectedResolucion) {
      updatedOpIncidentData = updatedOpIncidentData?.filter(
        (opIncidentRow: any) => {
          return opIncidentRow.solutionTime === this.selectedResolucion;
        }
      );
    }

    if (this.selectedOpIncidentType) {
      updatedOpIncidentData = updatedOpIncidentData?.filter(
        (opIncidentRow: any) => {
          return opIncidentRow.opIncidentType === this.selectedOpIncidentType;
        }
      );
    }

    this.opIncidentTableSource.data = updatedOpIncidentData;
  }

  onApplyRangeSelected() {
    if (!this.startDate && !this.endDate) {
      return;
    }

    if (this.startDate) {
      const start = new Date(this.startDate);
      start.setHours(0, 0, 0, 0);
      this.startDateSelected = start;
    } else {
      this.startDateSelected = null;
    }

    if (this.endDate) {
      const end = new Date(this.endDate);
      end.setHours(23, 59, 59, 999);
      this.endDateSelected = end;
    } else {
      this.endDateSelected = null;
    }

    this.applyFilterSelect();
  }

  cleanDateSelected() {
    this.startDate = null;
    this.startDateSelected = null;
    this.endDate = null;
    this.endDateSelected = null;

    this.applyFilterSelect();
  }
}
